import { Select, Spin } from 'antd'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ISelectOption } from '../../models/utils/selectOption'
import { defaultFilterOption } from '../../utils'
import { useGetDataOnScroll } from '../getDataOnScrollProps/useGetDataOnScrollProps'
import { getCookie } from 'typescript-cookie'
import { useLazyGetVeterinaryProductCategoryListQuery } from '../../redux/api/handBooksApi/veterinary/veterinaryProductionCategoryApi'
import { EntDirectoryInfoName } from '../../models/directoryInfoName'
import { EntTransportCategoryFilter } from '../../models/filters/transportCategoryFilter'

interface IProps {
	value?: number | null
	onChange?: (v: number) => void
}

const SelectVeterinaryProductCategory = (props: IProps) => {
	const { t } = useTranslation()
	const [options, setOptions] = useState<ISelectOption[]>([])

	const [getData] = useLazyGetVeterinaryProductCategoryListQuery()
	const { fetching, data, setData, setFetching, setFilter, scrollHandler, setCurrentPage } =
		useGetDataOnScroll<EntDirectoryInfoName, EntTransportCategoryFilter>({
			initialFilter: new EntTransportCategoryFilter(),
			query: getData,
		})

	useEffect(() => {
		const optionss = Array.from(new Set(data)).map(a => {
			return {
				label: getCookie('i18next') === 'ky' ? `${a.nameKy}` : `${a.nameRu}`,
				value: a.id ?? '',
			}
		})
		setOptions(optionss)
	}, [data])

	const search = (value?: string) => {
		if (!value) return
		const filter = new EntTransportCategoryFilter()
		filter.name = value
		setFilter(filter)
		setData([])
		setCurrentPage(0)
		setFetching(true)
	}

	const clear = () => {
		const filter = new EntTransportCategoryFilter()
		filter.name = null
		setFilter(filter)
		setData([])
		setCurrentPage(0)
		setFetching(true)
	}

	return (
		<Select
			placeholder={t('msg.selectPlaceholder')}
			onClear={clear}
			onSearch={search}
			onPopupScroll={scrollHandler}
			loading={fetching}
			value={props.value}
			onChange={props.onChange}
			options={options}
			filterOption={defaultFilterOption}
			showSearch
			allowClear
			dropdownRender={menu => <Spin spinning={fetching}>{menu}</Spin>}
		/>
	)
}

export default SelectVeterinaryProductCategory
